import Header from "../components/Header";
import { motion } from "motion/react";
import { routeVariants } from "../routesVariants";
import { Title } from "../uikit";

import { useTranslation } from "react-i18next";
import Policies from "../components/Policies";

export default function TermsAndPolicies() {
  const { t, _ } = useTranslation();
  return (
    <motion.div
      className="container background-regular column-spacing border-padding column"
      variants={routeVariants}
      initial="initial"
      animate="final"
      exit="exit"
    >
      <Header isBack={true}>
        <Title level="1" weight="3">
          {t("Information")}
        </Title>
      </Header>
      <Policies />
    </motion.div>
  );
}
